import React from 'react';
import ExpenseResolutionWorkspace from './ExpenseResolutionWorkspace';

/** 지출결의승인 */
export default function ExpenseResolutionApprove() {
  return <ExpenseResolutionWorkspace screenMode="approve" />;
}
